import ReactGA from 'react-ga4'
import { TrackingActions } from './tracking-actions'

export default class GoogleAnalyticsHelper {
  public static trackEvent = (payload: TrackingActions): void => {
    // we want only to track production
    if (!process.env.REACT_APP_GA_TRACKING_ID) {
      return
    }

    ReactGA.event(payload)
  }
}
